import { render, staticRenderFns } from "./CasoByIdView.vue?vue&type=template&id=1341e86c"
import script from "./CasoByIdView.vue?vue&type=script&lang=js"
export * from "./CasoByIdView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports